import { Dispatch, SetStateAction } from "react";
import { MenuTypes } from "typing";
import { FirstLevelCategories } from "../components/FirstLevelCategories";
import { SubCategories } from "../components/SubCategories";

interface SubCategoriesProps {
  level: MenuTypes;
  setCategoriesLevel: Dispatch<SetStateAction<MenuTypes>>;
  onCloseSidebarMenu: () => void;
}

const CategoriesSection = ({
  level,
  onCloseSidebarMenu,
  setCategoriesLevel,
}: SubCategoriesProps) => {
  if (level === "FirstLevel") {
    return (
      <FirstLevelCategories
        onCloseSidebarMenu={onCloseSidebarMenu}
        setCategoriesLevel={setCategoriesLevel}
      />
    );
  }

  return (
    <SubCategories
      level={level}
      setCategoriesLevel={setCategoriesLevel}
      onCloseSidebarMenu={onCloseSidebarMenu}
    />
  );
};

export { CategoriesSection };
